import styled, { css } from 'styled-components';
import { setButtonStates, setButtonTransparentStates, ButtonLarge, ButtonMedium, ButtonSmall, ButtonXSmall } from '../styles.js';
import { getColorAlias, getDarkenColor } from '../../../utils/index.js';

const PrimaryButtonOrange = css `
  background-color: ${getColorAlias('interactiveBrand')};
  color: ${getColorAlias('contentInteractivePrimary')};
  ${setButtonStates('interactiveBrand')};

  svg {
    fill: ${getColorAlias('contentInteractiveBrand')};
  }

  :disabled:hover {
    background-color: ${getColorAlias('disabled01')};
    color: ${getColorAlias('contentDisabled')};
  }

  ${(props) => props.isLoading &&
    css `
      &,
      :disabled,
      :disabled:hover {
        background-color: ${getDarkenColor('active01', 'interactiveBrand')};
      }
    `}
`;
const PrimaryButtonBlack = css `
  background-color: ${getColorAlias('interactivePrimary')};
  color: ${getColorAlias('contentInteractivePrimary')};
  ${setButtonTransparentStates('interactivePrimary')};

  svg {
    fill: ${getColorAlias('contentInteractivePrimary')};
  }

  :disabled:hover {
    background-color: ${getColorAlias('disabled01')};
    color: ${getColorAlias('contentDisabled')};
  }

  ${(props) => props.isLoading &&
    css `
      &,
      :disabled,
      :disabled:hover {
        background-color: ${getDarkenColor('active01', 'interactivePrimary')};
      }
    `}
`;
const PrimaryButtonLarge = styled(ButtonLarge) `
  ${PrimaryButtonOrange};
`;
const PrimaryButtonMedium = styled(ButtonMedium) `
  ${PrimaryButtonOrange};
`;
const PrimaryButtonSmall = styled(ButtonSmall) `
  ${PrimaryButtonOrange};
`;
const PrimaryButtonSmallAlt = styled(ButtonSmall) `
  ${PrimaryButtonBlack};
`;
const PrimaryButtonXSmall = styled(ButtonXSmall) `
  ${PrimaryButtonBlack};
`;
const PrimaryInverseButton = css `
  background-color: ${getColorAlias('interactiveInverse')};
  color: ${getColorAlias('contentInteractiveInverse')};
  ${setButtonStates('interactiveInverse')};

  svg {
    fill: ${getColorAlias('contentInteractiveInverse')};
  }

  :disabled:hover {
    background-color: ${getColorAlias('disabled01')};
    color: ${getColorAlias('contentDisabled')};
  }

  ${(props) => props.isLoading &&
    css `
      &,
      :disabled,
      :disabled:hover {
        background-color: ${getDarkenColor('active01', 'interactiveInverse')};
      }
    `}
`;
const PrimaryInverseButtonLarge = styled(ButtonLarge) `
  ${PrimaryInverseButton};
`;
const PrimaryInverseButtonMedium = styled(ButtonMedium) `
  ${PrimaryInverseButton};
`;
const PrimaryInverseButtonSmall = styled(ButtonSmall) `
  ${PrimaryInverseButton};
`;
const PrimaryInverseButtonXSmall = styled(ButtonXSmall) `
  ${PrimaryInverseButton};
`;

export { PrimaryButtonLarge, PrimaryButtonMedium, PrimaryButtonSmall, PrimaryButtonSmallAlt, PrimaryButtonXSmall, PrimaryInverseButtonLarge, PrimaryInverseButtonMedium, PrimaryInverseButtonSmall, PrimaryInverseButtonXSmall };
